import { FrameWorkFormatDate, FrameWorkGetPrimaryColorButton, FrameWorkHideAlert, FrameWorkMessageErrorAlert, FrameWorkSimpleMessageState, OrdenExpressNavegatePath, OrdenExpressValidateSecurity } from 'orden_express/frameWork/frameWork.js';
import { setDataOrderForShowAndEdit } from 'orden_express/orders/ordersActions.js';
import { setDateReportsRequested, setfFilterRouteReportProducts, setMessageReportsRequested } from 'orden_express/reports/reportsActions.js';
import { requestGetReportProductsRequested } from 'orden_express/reports/reportsEpic.js';
import { requestGetRoutes } from 'orden_express/routes/routesEpic.js';
import React from 'react';
import ReactDatetime from 'react-datetime';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Button, Card, CardBody, Col, FormGroup, Input, Row, UncontrolledTooltip } from 'reactstrap';
import { bindActionCreators } from 'redux';


class ReportProducts extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      alert: '',
      filterText: '',
    }
    OrdenExpressValidateSecurity(this);
    this.props.requestGetRoutes();
  }

  componentDidMount() {
    this.changeSelectDate(this.props.reportsReducerState.dateReportsRequested);
  }

  componentDidUpdate(prevProps) {
    if (this.props.reportsReducerState.messageReportsRequested !== prevProps.reportsReducerState.messageReportsRequested) {
      this.processMessageState(this.props.reportsReducerState.messageReportsRequested);
    }
  }

  processMessageState = (pStateForMessage) => {
    switch (pStateForMessage) {
      case 1://procesando solicitud
        FrameWorkSimpleMessageState(this, 'Recuperando información', 'Se está procesando ...');
        break;
      case 2:
        FrameWorkHideAlert(this);
        this.props.setMessageReportsRequested(0);
        break;
      case 3:
        var localMessageError = this.props.reportsReducerState.responseGetReportProductsRequested;
        FrameWorkMessageErrorAlert(this, 'Error :(', localMessageError.message);
        console.error(localMessageError)
        break;
      default:
        FrameWorkHideAlert(this);
        this.props.setMessageReportsRequested(0);
        break;
    }
  }

  processReport = (pData) => {
    var result = {};
    var pos = 0;
    var length = pData.length;
    while (pos < length) {
      var pContent = pData[pos];
      var localNameProduct = pContent.nameProduct + ' (' + pContent.measureUnit + ')';
      if (!result[localNameProduct]) {
        result[localNameProduct] = {
          quantity: pContent.quantity,
          measureUnit: pContent.measureUnit,
          nameProduct: pContent.nameProduct,
          idProduct: pContent.idProduct,
          weight: pContent.equityWeight * pContent.quantity,
          detail: [pContent]
        };
      } else {
        result[localNameProduct].quantity += pContent.quantity;
        result[localNameProduct].weight = result[localNameProduct].quantity * pContent.equityWeight;
        result[localNameProduct].detail.push(pContent);
      }
      pos++;
    }
    /*pData.map((pContent) => {
      var localNameProduct = pContent.nameProduct + ' (' + pContent.measureUnit + ')';
      if (!result[localNameProduct]) {
        result[localNameProduct] = {
          quantity: pContent.quantity,
          measureUnit: pContent.measureUnit,
          nameProduct: pContent.nameProduct,
          idProduct: pContent.idProduct,
          weight: pContent.equityWeight * pContent.quantity,
          detail: [pContent]
        };
      } else {
        result[localNameProduct].quantity += pContent.quantity;
        result[localNameProduct].weight = result[localNameProduct].quantity * pContent.equityWeight;
        result[localNameProduct].detail.push(pContent);
      }
    })*/
    return result;
  }

  changeSelectDate = (pValue) => {
    this.props.setDateReportsRequested(pValue);
    this.props.setMessageReportsRequested(1);
    var dataForSelected = FrameWorkFormatDate(pValue, '-');
    this.props.requestGetReportProductsRequested(dataForSelected);
  }

  sendToEditOrderRequested = (pData = null) => {
    pData['id'] = pData.idOrder;
    this.props.setDataOrderForShowAndEdit(pData);
    //this.props.history.push('/admin/editOrder');
    OrdenExpressNavegatePath(this, 'editOrder');
  }

  renderFilters = () => {
    return (
      <FormGroup >
        <Input

          type='text'
          placeholder='Buscar'
          id='idfilterText'
          value={this.state.filterText}
          onChange={(newtext) => { this.setState({ filterText: newtext.target.value }) }}
        />
      </FormGroup>
    )
  }

  applyFilters = (pContentReport) => {
    try {
      var filter = this.state.filterText.toUpperCase();
      var result = [];
      var localText = '';
      var pos = 0;
      var length = pContentReport.length;
      while (pos < length) {
        var pContent = pContentReport[pos];
        localText =
          (
            pContent.nameProduct + ' ' +
            pContent.measureUnit + ' ' +
            pContent.idProduct + ' '
          );
        localText = localText.toUpperCase();
        var addToShow = localText.includes(filter);
        if (addToShow) {
          result.push(pContent);
        }
        pos++;
      }
      /*pContentReport.map((pContent) => {
        localText =
          (
            pContent.nameProduct + ' ' +
            pContent.measureUnit + ' ' +
            pContent.idProduct + ' '
          );
        localText = localText.toUpperCase();
        var addToShow = localText.includes(filter);
        if (addToShow) {
          result.push(pContent);
        }
      });*/
    } catch (ex) {
      return pContentReport;
    }
    return result;
  }

  applyFilterRoute = (pContentReport) => {
    var result = [];
    var localFilter = '';

    try {
      localFilter = this.props.reportsReducerState.filterRouteReportProducts.value || '';
    } catch (__) { }


    if (localFilter === '@') {
      return pContentReport;
    }
    if (localFilter === '') {
      localFilter = 0;
    }
    localFilter = parseInt(localFilter, 10);
    var pos = 0;
    var length = pContentReport.length;
    while (pos < length) {
      var pContent = pContentReport[pos];
      if (pContent.idRoute === localFilter) {
        result.push(pContent);
      }
      pos++;
    }
    /*pContentReport.map((pContent) => {
      if (pContent.idRoute == localFilter) {
        result.push(pContent);
      }
    });*/

    return result;
  }

  getRoutesForEditIntOrder = () => {
    try {
      var result = [{ value: '@', label: 'Todos' }, { value: '', label: 'Sin Asignar' }];
      var localData = this.props.routesReducerState.responseGetRoutes.result;
      if (localData === undefined) {
        return result;
      }
      var pos = 0;
      var length = localData.length;
      while (pos < length) {
        var itemRoute = localData[pos];
        if (itemRoute.active === 1) {
          result.push({ value: itemRoute.id, label: itemRoute.name, isDisabled: itemRoute.active !== 1 });
        }
        pos++;
      }
    } catch (__) { }
    return result;
  }

  render = () => {
    /*var report = this.applyFilters(this.props.reportsReducerState.responseGetReportProductsRequested.result || []);
    report = this.applyFilterRoute(report);*/

    var report = this.applyFilterRoute(this.props.reportsReducerState.responseGetReportProductsRequested.result || []);
    report = this.applyFilters(report);
    report = this.processReport(report);
    return (
      <div className='content mt-5 mb-0'>
        {this.state.alert}
        <div className='framework-flexcontainer'>
          <div>
            <h4>{'Consolidado'}</h4>
          </div>
          <div className='text-right framework-flex-rigth'>
          </div>
        </div>
        <Card className='mt-1 mb-1'>
          <CardBody>
            <Row className='framework-v-center'>
              <Col md='3'>
                <b>Fecha de despacho</b>
              </Col>
              <Col>
                <FormGroup>
                  <ReactDatetime
                    inputProps={{
                      className: 'form-control',
                      placeholder: 'Fecha de despacho',
                      readOnly: true
                    }}
                    defaultValue={this.props.reportsReducerState.dateReportsRequested}
                    readOnly={true}
                    dateFormat='YYYY-MM-DD'
                    onChange={(value) => { this.changeSelectDate(value) }}
                    timeFormat={false}
                    closeOnSelect={true}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row className='framework-v-center'>
              <Col md='3'>
                <b>Ruta</b>
              </Col>
              <Col>
                <Select
                  className='react-select'
                  classNamePrefix='react-select'
                  name='routeOrderRequested'
                  placeholder='Seleccione la ruta'
                  value={this.props.reportsReducerState.filterRouteReportProducts}
                  options={
                    this.getRoutesForEditIntOrder()
                  }
                  onChange={value => {
                    this.props.setfFilterRouteReportProducts(value);
                  }
                  }
                />
              </Col>
            </Row>
            <Row className='framework-v-center mt-2'>
              <Col md='3'>
                <b>Filtros</b>
              </Col>
              <Col>
                {this.renderFilters()}
              </Col>
            </Row>
          </CardBody>
        </Card>
        {
          Object.keys(report).map((pKey, pIndex) => {
            var pProduct = report[pKey];
            return (
              <Card
                className={`mb-1 mt-0 ${pIndex % 2 === 0 ? 'bg-gray' : 'bg-white'}`}
                key={`cardreportProducts${pIndex}`}
              >
                <CardBody>
                  <h6>
                    {pProduct.nameProduct}
                    {' ('}
                    {pProduct.measureUnit}
                    {')'}
                  </h6>
                  <b>{'Peso:'}</b>
                  {' '}
                  {pProduct.weight.toFixed(1)}
                  {pProduct.weight > 1 ? ' kilos' : ' kilo'}
                  {' '}
                  <b> {'Código:'}</b>
                  {' '}
                  {pProduct.idProduct}
                  {' '}
                  <b>{'Cantidad:'}</b>
                  {' '}
                  {pProduct.quantity}
                  {' '}
                  {pProduct.measureUnit}
                  {' '}

                  <hr />
                  {
                    pProduct.detail.map((pDetail, pIndexDetail) => {
                      return (
                        <div key={`detailCardReportProducts${pIndexDetail}${pIndex}`}
                          className={`btn-round mt-1 pl-3 pr-3 pt-1 ${pIndex % 2 === 1 ? 'bg-gray' : 'bg-white'}`}>
                          <div className='framework-flexcontainer'>
                            <div>
                              {' '}
                              {pDetail.quantity}
                              {' '}
                              {pDetail.measureUnit}
                              {' '}
                              {pDetail.nameUser}
                              {' '}
                              {'orden Nº'}
                              {pDetail.idOrder}
                              {' '}
                            </div>
                            <div className='text-right framework-flex-rigth'>
                              <Button
                                className='btn-icon btn-round mt-0 mb-1'
                                color={FrameWorkGetPrimaryColorButton()}
                                id={`editOrder${pIndexDetail}${pIndex}`}
                                type='button'
                                outline
                                size='sm'
                                onClick={value => {
                                  this.sendToEditOrderRequested(pDetail);
                                }}
                              >
                                <i className='fa fa-pencil' />
                              </Button>
                              <UncontrolledTooltip
                                delay={0}
                                target={`editOrder${pIndexDetail}${pIndex}`}
                              >
                                {'Detalle orden Nº'}
                                {' '}
                                {pDetail.idOrder}
                              </UncontrolledTooltip>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  }
                </CardBody>
              </Card>
            )
          })
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    reportsReducerState: state.reportsReducerState,
    loginReducerState: state.loginReducerState,
    routesReducerState: state.routesReducerState,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setDataOrderForShowAndEdit: (dataOrderForShowAndEdit) => dispatch(setDataOrderForShowAndEdit(dataOrderForShowAndEdit)),
    setMessageReportsRequested: (messageReportsRequested) => dispatch(setMessageReportsRequested(messageReportsRequested)),
    setDateReportsRequested: (dateReportsRequested) => dispatch(setDateReportsRequested(dateReportsRequested)),
    setfFilterRouteReportProducts: (filterRouteReportProducts) => dispatch(setfFilterRouteReportProducts(filterRouteReportProducts)),

    requestGetRoutes: () => bindActionCreators(dispatch(requestGetRoutes()), dispatch),
    requestGetReportProductsRequested: (deliveryDate) => bindActionCreators(dispatch(requestGetReportProductsRequested(deliveryDate)), dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportProducts);